import { FlowsheetConstants } from "../FlowsheetConstants";
import { CareComponent } from "../Models/CareElements/CareComponent";
import { ActiveMedicationCareComponentService } from "./ActiveMedicationCareComponentService";
import { FlowsheetRiskFactorService } from "./FlowsheetRiskFactorService";
import { ICareComponentService } from "./ICareComponentService";
import { ImmunizationsCareComponentService } from "./ImmunizationsCareComponentService";
import { VitalSignsCareComponentService } from "./VitalSignsCareComponentService";

class FlowsheetLoadMedicalItemData {
    private static serviceRegistry: Record<string, ICareComponentService> = {};

    public static registerService(componentName: string, service: ICareComponentService): typeof FlowsheetLoadMedicalItemData {
        this.serviceRegistry[componentName] = service;

        return this;
    }

    public static setFlowsheetState(careComponents: CareComponent[], patientContactId: string, encounterDate: Date): CareComponent[] {
        careComponents.forEach(careComponent => {
            const service = this.serviceRegistry[careComponent.Name];
            if (service) {
                service.processCareComponent(careComponent, patientContactId, encounterDate);
            }
        });

        return careComponents;
    }
}

FlowsheetLoadMedicalItemData
    .registerService(FlowsheetConstants.Medication.CareComponentName, new ActiveMedicationCareComponentService())
    .registerService(FlowsheetConstants.VitalSigns.CareComponentName, new VitalSignsCareComponentService())
    .registerService(FlowsheetConstants.Immunizations.CareComponentName, new ImmunizationsCareComponentService())
    .registerService(FlowsheetConstants.RiskFactors.CareComponentName, new FlowsheetRiskFactorService());

export { FlowsheetLoadMedicalItemData };
